import { render } from "./LabelsScroll.vue?vue&type=template&id=cc857f82&scoped=true"
import script from "./LabelsScroll.vue?vue&type=script&lang=js"
export * from "./LabelsScroll.vue?vue&type=script&lang=js"

import "./LabelsScroll.vue?vue&type=style&index=0&id=cc857f82&scoped=true&lang=css"

import exportComponent from "/prj/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc857f82"]])

export default __exports__